var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9967 16.2857C16.9338 16.2857 19.7109 13.5085 19.7109 8.5714C19.7109 3.63426 16.9338 0.857117 11.9967 0.857117C7.05952 0.857117 4.28238 3.63426 4.28238 8.5714C4.28238 13.5085 7.05952 16.2857 11.9967 16.2857Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6379 6.32286C13.4981 5.75758 13.3083 5.24485 13.0561 4.76746C12.599 3.90229 11.4048 3.90217 10.9469 4.76691C10.6941 5.24446 10.5036 5.75735 10.3638 6.32286C9.80752 6.30305 9.27781 6.33347 8.76022 6.42027C7.77839 6.58491 7.37819 7.7313 8.07548 8.44186C8.44359 8.81698 8.86419 9.14439 9.35137 9.43871C9.16871 9.93714 9.0418 10.4289 8.96596 10.9262C8.81216 11.9346 9.80728 12.6881 10.7163 12.2253C11.1641 11.9973 11.5872 11.7133 11.9998 11.3644C12.4128 11.7136 12.8366 11.9977 13.2852 12.2258C14.1945 12.6881 15.1895 11.9346 15.0357 10.9262C14.9599 10.4289 14.833 9.93714 14.6503 9.43871C15.1375 9.14439 15.5581 8.81698 15.9262 8.44186C16.6235 7.7313 16.2233 6.58491 15.2415 6.42027C14.7239 6.33347 14.1942 6.30305 13.6379 6.32286Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2546 14.6871C15.9671 15.7349 14.1963 16.2861 11.9968 16.2861C9.8008 16.2861 8.03213 15.7367 6.7451 14.6921C6.61812 15.8087 6.42871 17.7069 6.42871 19.0953C6.42871 19.8624 6.48653 20.7851 6.5597 21.6456C6.66813 22.9209 8.10693 23.5665 9.16152 22.8415L12.0001 20.89L14.8388 22.8415C15.8934 23.5665 17.3321 22.9209 17.4406 21.6456C17.5138 20.7851 17.5716 19.8624 17.5716 19.0953C17.5716 17.7048 17.3816 15.803 17.2546 14.6871Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadges);
export default __webpack_public_path__ + "static/media/badges.70230b91c68464135747bbabc8472fde.svg";
export { ForwardRef as ReactComponent };